import type { TourDefinition } from '../types'

export const auditTour: TourDefinition = {
  id: 'audit',
  title: 'Audit Log Tour',
  description: 'Navigate the immutable audit trail for compliance and security reviews.',
  icon: 'ScrollText',
  roles: ['tenant_owner', 'tenant_admin', 'tenant_viewer'],
  route: '/tenant/audit',
  estimatedMinutes: 2,
  steps: [
    {
      element: '[data-tour-id="audit-log-table"]',
      popover: {
        title: 'Audit Log',
        description: 'Every create, update, delete, and execution event is recorded here. Records are immutable — never edited or deleted.',
      },
      aiContext: 'What compliance standards does the Vharta audit log help satisfy?',
    },
    {
      element: '[data-tour-id="audit-filters"]',
      popover: {
        title: 'Filter Events',
        description: 'Filter by actor, resource type, date range, or event type to find specific events quickly.',
      },
      aiContext: 'How do I search the audit log for all actions taken by a specific user?',
    },
    {
      element: '[data-tour-id="audit-export-btn"]',
      popover: {
        title: 'Export for Compliance',
        description: 'Export filtered audit records as CSV for your security or compliance team.',
      },
      roles: ['tenant_owner', 'tenant_admin'],
      aiContext: 'What fields are included in the audit log CSV export?',
    },
  ],
}
